var map = {
	"./level1/pic10-2.png": [
		48275,
		48275
	],
	"./level1/pic11-2.png": [
		65023,
		65023
	],
	"./level1/pic12-2.png": [
		8152,
		8152
	],
	"./level1/pic14-2.png": [
		74405,
		74405
	],
	"./level1/pic15-2.png": [
		3505,
		3505
	],
	"./level1/pic16-2.png": [
		19755,
		19755
	],
	"./level1/pic17-2.png": [
		94109,
		94109
	],
	"./level1/pic18-2.png": [
		9126,
		9126
	],
	"./level1/pic2-2.png": [
		29669,
		29669
	],
	"./level1/pic20-2.png": [
		24418,
		24418
	],
	"./level1/pic21-2.png": [
		54284,
		54284
	],
	"./level1/pic22-2.png": [
		27726,
		27726
	],
	"./level1/pic23-2.png": [
		33158,
		33158
	],
	"./level1/pic24-2.png": [
		7430,
		7430
	],
	"./level1/pic26-2.png": [
		43377,
		43377
	],
	"./level1/pic27-2.png": [
		99689,
		99689
	],
	"./level1/pic28-2.png": [
		491,
		491
	],
	"./level1/pic29-2.png": [
		21020,
		21020
	],
	"./level1/pic3-2.png": [
		38706,
		38706
	],
	"./level1/pic30-2.png": [
		84705,
		84705
	],
	"./level1/pic32-2.png": [
		48863,
		48863
	],
	"./level1/pic33-2.png": [
		6945,
		6945
	],
	"./level1/pic34-2.png": [
		99209,
		99209
	],
	"./level1/pic35-2.png": [
		54017,
		54017
	],
	"./level1/pic36-2.png": [
		84570,
		84570
	],
	"./level1/pic38-2.png": [
		78548,
		78548
	],
	"./level1/pic39-2.png": [
		77037,
		77037
	],
	"./level1/pic4-2.png": [
		18999,
		18999
	],
	"./level1/pic40-2.png": [
		65667,
		65667
	],
	"./level1/pic41-2.png": [
		5300,
		5300
	],
	"./level1/pic42-2.png": [
		90923,
		90923
	],
	"./level1/pic44-2.png": [
		29469,
		29469
	],
	"./level1/pic45-2.png": [
		91465,
		91465
	],
	"./level1/pic46-2.png": [
		11998,
		11998
	],
	"./level1/pic47-2.png": [
		18447,
		18447
	],
	"./level1/pic48-2.png": [
		62526,
		62526
	],
	"./level1/pic5-2.png": [
		1728,
		1728
	],
	"./level1/pic6-2.png": [
		97605,
		97605
	],
	"./level1/pic8-2.png": [
		34530,
		34530
	],
	"./level1/pic9-2.png": [
		99922,
		99922
	],
	"./level2/pic10-2.png": [
		65818,
		65818
	],
	"./level2/pic11-2.png": [
		53973,
		53973
	],
	"./level2/pic12-2.png": [
		18272,
		18272
	],
	"./level2/pic14-2.png": [
		16975,
		16975
	],
	"./level2/pic15-2.png": [
		39269,
		39269
	],
	"./level2/pic16-2.png": [
		53289,
		53289
	],
	"./level2/pic17-2.png": [
		67117,
		67117
	],
	"./level2/pic18-2.png": [
		28237,
		28237
	],
	"./level2/pic2-2.png": [
		87645,
		87645
	],
	"./level2/pic20-2.png": [
		22585,
		22585
	],
	"./level2/pic21-2.png": [
		19872,
		19872
	],
	"./level2/pic22-2.png": [
		38033,
		38033
	],
	"./level2/pic23-2.png": [
		41262,
		12216
	],
	"./level2/pic24-2.png": [
		69092,
		69092
	],
	"./level2/pic26-2.png": [
		22470,
		22470
	],
	"./level2/pic27-2.png": [
		91808,
		91808
	],
	"./level2/pic28-2.png": [
		61790,
		61790
	],
	"./level2/pic29-2.png": [
		99691,
		99691
	],
	"./level2/pic3-2.png": [
		67589,
		67589
	],
	"./level2/pic30-2.png": [
		45584,
		45584
	],
	"./level2/pic32-2.png": [
		72033,
		72033
	],
	"./level2/pic33-2.png": [
		35175,
		35175
	],
	"./level2/pic34-2.png": [
		13647,
		13647
	],
	"./level2/pic35-2.png": [
		96719,
		96719
	],
	"./level2/pic36-2.png": [
		49457,
		49457
	],
	"./level2/pic38-2.png": [
		91883,
		91883
	],
	"./level2/pic39-2.png": [
		25825,
		25825
	],
	"./level2/pic4-2.png": [
		21532,
		21532
	],
	"./level2/pic40-2.png": [
		22574,
		22574
	],
	"./level2/pic41-2.png": [
		72917,
		72917
	],
	"./level2/pic42-2.png": [
		21171,
		21171
	],
	"./level2/pic44-2.png": [
		24747,
		24747
	],
	"./level2/pic45-2.png": [
		60642,
		60642
	],
	"./level2/pic46-2.png": [
		52498,
		52498
	],
	"./level2/pic47-2.png": [
		7610,
		7610
	],
	"./level2/pic48-2.png": [
		49148,
		49148
	],
	"./level2/pic5-2.png": [
		8297,
		8297
	],
	"./level2/pic6-2.png": [
		20910,
		20910
	],
	"./level2/pic8-2.png": [
		66787,
		66787
	],
	"./level2/pic9-2.png": [
		32164,
		32164
	],
	"./level3/pic10-2.png": [
		80884,
		80884
	],
	"./level3/pic11-2.png": [
		14062,
		14062
	],
	"./level3/pic12-2.png": [
		16111,
		16111
	],
	"./level3/pic14-2.png": [
		78952,
		78952
	],
	"./level3/pic15-2.png": [
		67628,
		67628
	],
	"./level3/pic16-2.png": [
		80338,
		80338
	],
	"./level3/pic17-2.png": [
		88,
		88
	],
	"./level3/pic18-2.png": [
		66059,
		66059
	],
	"./level3/pic2-2.png": [
		23462,
		23462
	],
	"./level3/pic20-2.png": [
		67123,
		67123
	],
	"./level3/pic21-2.png": [
		50450,
		50450
	],
	"./level3/pic22-2.png": [
		99559,
		99559
	],
	"./level3/pic23-2.png": [
		36553,
		36553
	],
	"./level3/pic24-2.png": [
		13805,
		13805
	],
	"./level3/pic3-2.png": [
		24392,
		24392
	],
	"./level3/pic4-2.png": [
		50175,
		50175
	],
	"./level3/pic5-2.png": [
		23799,
		23799
	],
	"./level3/pic6-2.png": [
		10385,
		10385
	],
	"./level3/pic8-2.png": [
		48019,
		48019
	],
	"./level3/pic9-2.png": [
		29781,
		29781
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 34312;
module.exports = webpackAsyncContext;